import { render, staticRenderFns } from "./JobUnitQueryList.vue?vue&type=template&id=23f6f529&scoped=true&"
import script from "./JobUnitQueryList.vue?vue&type=script&lang=js&"
export * from "./JobUnitQueryList.vue?vue&type=script&lang=js&"
import style0 from "./JobUnitQueryList.vue?vue&type=style&index=0&id=23f6f529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6f529",
  null
  
)

export default component.exports